jQuery(document).ready(function() {

  // MENU
  function noScroll() {
    window.scrollTo(0, 0);
  };

  function menuMobile() {
    $('html').toggleClass('is-menu-mobile-open');
    if($('html').hasClass('is-menu-mobile-open')) {
      window.addEventListener('scroll', noScroll)
    } else {
      window.removeEventListener('scroll', noScroll)
    }
  }

  $('html.ios').on('touchend', '.js-nav-mobile-toggle', function(e) {
    menuMobile();
  });
  $('html.android').on('touchend', '.js-nav-mobile-toggle', function(e) {
    menuMobile();
  });
  $('html:not(.ios):not(.android)').on('click', '.js-nav-mobile-toggle', function(e) {
    menuMobile();
  });

  // accordion
  $('.accordion').on('click', '.accordion__head, [data-accordion]', function(e){
    e.preventDefault();
    var $this = $(this);
    var $thisParent = $this.closest('.accordion');
    var $body = $thisParent.children('.accordion__body');
    var $dataAcc = $this.attr('data-accordion');

    // all accordions - click on head
    if(!$this.attr('data-accordion')) {
      if(!$thisParent.hasClass('is-active')) {
        $thisParent
          .parent()
          .find('.accordion')
          .removeClass('is-active')
          .find('.accordion__body')
          .slideUp(300);

        $body.slideDown(300);
        $thisParent.addClass('is-active');

        // scrollTop animate (checkout main)
        if($this.hasClass('js-accordion-scroll')) {
          // scrollTop animate
          setTimeout(function(){
            $('html, body').animate({
              scrollTop: $this.offset().top
            }, 500);
          }, 300);
        }

        return false;

      } else {
        $body.slideUp(300);
        $thisParent.removeClass('is-active');
        return false;
      }
    } else {
      // only click to button with attr

      $thisParent
        .parent()
        .find('.accordion')
        .removeClass('is-active')
        .find('.accordion__body')
        .slideUp(300);

      $('[data-accordion-parent=' + $dataAcc + ']')
        .addClass('is-active')
        .find('.accordion__body')
        .slideDown(300);

      setTimeout(function(){
        $('html, body').animate({
          scrollTop: $('[data-accordion-parent=' + $dataAcc + ']').offset().top
        }, 500);
      }, 300);
    }
  });

  // PLUGINS
  if($.fn.owlCarousel) {
    var $carousel = $('.carousel .owl-carousel').owlCarousel({
      items: 4,
      margin: 10,
      loop: false,
      nav: true,
      dots: false,
      autoplay: false,
      autoplayTimeout: 5000,
      autoplayHoverPause: false,
      stagePadding: 0,
      navText: ['<i class="i i-arrow-left"></i>','<i class="i i-arrow-right"></i>'],
      navSpeed: 300,
      dotsSpeed: 300,
      dragEndSpeed: 300,
      fluidSpeed: 300,
      responsiveClass: true,
      mouseDrag: true,
      responsive : {
        0 : {
          items: 2
        },
        350 : {
          items: 2
        },
        768 : {
          items: 3
        },
        1440 : {
          items: 4,
          margin: 20
        },
      }
    });
  }

  // lightbox
  if($.fn.magnificPopup) {
    $('[data-gallery]').magnificPopup({
      delegate: '[data-gallery-item]',
      type: 'image',
      gallery: {
        enabled: true,
        arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir% i i-arrow-%dir%"></button>'
      },
      closeMarkup: '<i class="mfp-close i i-cross"></i>',
      zoom: {
        enabled: false,
      },
      mainClass: 'mfp-fade mfp-image',
      fixedContentPos: true,
      callbacks: {
        beforeOpen: function() {
         if(!device.android()) {
            document.ontouchmove = function(e){ e.preventDefault()};
         } else {
            $('html').css('overflow', 'hidden');
         }
        },
        close: function() {
          if(!device.android()) {
            document.ontouchmove = function(e){ e.stopPropagation()};
          } else {
            $('html').css('overflow', 'auto');
          }
        }
      }
    });
  }

  // MAP
  if($('#map').length) {
    function initMap() {
      var myLatLng = {lat: 50.7860851, lng: 16.8450802};

      var $markerUrl = $('#map').data('marker-url');

      var $windowWidth = $(window).outerWidth();

      if($windowWidth < 1199) {
        var $mapCenter = myLatLng;
      } else {
        var $mapCenter = {lat: myLatLng.lat, lng: myLatLng.lng - 0.018};
      }

      var map = new google.maps.Map(document.getElementById('map'), {
        center: $mapCenter,
        zoom: 15,
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        styles: [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]
      });
      var icon = {
          url: $markerUrl,
          scaledSize: new google.maps.Size(44, 60)
      };
      var marker = new google.maps.Marker({
        position: myLatLng,
        map: map,
        icon: icon,
      });
    }
    initMap();
  }
});
